import { Combobox as BaseCombobox, type ComboboxGroupLabelProps } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { groupLabelStyle } from '../form.css';

type Props = ComboboxGroupLabelProps;

export const ComboboxGroupLabel = ({ ...delegated }: Props) => {
  return <BaseCombobox.GroupLabel {...delegated} className={clsxs(groupLabelStyle, delegated.className)} />;
};
